export const config = {
  title: "DVO General Construction LLC | Quality Construction Services in Tampa, FL",
  meta: {
    description:
      "DVO General Construction LLC offers top-tier residential and commercial construction services in Tampa, FL, specializing in new builds, renovations, remodeling, and project management.",
    keywords: [
      'General Construction Tampa',
      'Residential Construction',
      'Commercial Construction',
      'DVO General Construction LLC',
      'New Builds',
      'Renovations',
      'Remodeling',
      'Project Management',
      'Carpentry Services',
      'Drywall Installation'
    ],
    author: "DVO General Construction LLC",
    canonicalUrl: 'https://dvogeneralconstructionllc.com/',
  },
  sections: {
    header: {
      businessName: "DVO General Construction LLC",
    },
    sectionB: {
      heroTitle: "DVO General Construction LLC",
      heroSubtitle: 'Quality You Can Trust in Tampa, FL',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '8135663901',
      phoneLabel: '(813) 566-3901',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1400405020/photo/modern-wooden-house-construction-site-at-daylight.jpg?s=612x612&w=0&k=20&c=GtIaRUcbyD_2watbZraYEtEsiDB1CCb3DZjq2G0Xz3E=",
      cardData: [
        {
          title: 'Our Mission',
          description:
            'At DVO General Construction LLC, our mission is to provide high-quality construction solutions with exceptional customer service, ensuring your project is completed to the highest standards.',
        },
        {
          title: 'Our Vision',
          description:
            'We aim to be the leading construction service provider in Tampa, recognized for our reliability, expertise, and commitment to customer satisfaction.',
        },
        {
          title: 'Why Choose Us',
          description:
            'With over 4 years of experience and a team of skilled professionals, we offer personalized services tailored to meet your specific construction needs.',
        },
      ],
      description:
        "DVO General Construction LLC specializes in comprehensive construction services, including new builds, renovations, remodeling, and project management for both residential and commercial clients, ensuring your property meets your vision and functional requirements.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore the range of professional construction services we offer to enhance and build your property.",
      cards: [
        {
          title: 'Carpentry',
          description:
            'Expert carpentry services to add functional and aesthetic value to your property.',
          imageSrc:
            'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/wVfI6GEBPTExqYSPhnaO/media/67b6429783fcbc6d79558bd7.png',
          imageAlt: 'Carpentry Services',
        },
        {
          title: 'Framing',
          description:
            'Professional framing services to ensure the structural integrity of your construction projects.',
          imageSrc:
            'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/wVfI6GEBPTExqYSPhnaO/media/67b64297145bb77aae2d1c05.png',
          imageAlt: 'Framing Services',
        },
        {
          title: 'Metal Framing',
          description:
            'Durable and precise metal framing solutions for commercial and industrial buildings.',
          imageSrc:
            'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/wVfI6GEBPTExqYSPhnaO/media/67b642973006305e6475cf5c.png',
          imageAlt: 'Metal Framing Services',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Cabinet Installation',
        'Baseboard Installation',
        'Drywall Installation & Repair',
        'Window Installation',
        'Wood Flooring Installation',
        'Tile Flooring Installation',
        'Pressure Washing',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/wVfI6GEBPTExqYSPhnaO/media/67b718a2c2a016225fe85bdf.png',
        alt: "DVO General Construction LLC Team",
      },
      aboutText: [
        "DVO General Construction LLC is a locally owned and operated company dedicated to providing exceptional construction services in Tampa, FL.",
        "Our team of professionals is committed to ensuring your project's success through reliable and efficient solutions.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "DVO General Construction LLC",
      businessName: "DVO General Construction LLC",
      contact: {
        phone: '8135663901',
        phoneLabel: '(813) 566-3901',
        email: 'info@dvogeneralconstructionllc.com',
        website: 'https://dvogeneralconstructionllc.com/',
        address: '1805 E Wood St, Tampa, FL 33064, United States',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '1805 E Wood St, Tampa, FL 33064, United States',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.123456789012!2d-82.4531234!3d27.9652345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2b1234567890b%3A0x1234567890abcdef!2s1805%20E%20Wood%20St%2C%20Tampa%2C%20FL%2033064%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
